export default {
  Model: {
    SLUG: 'slug',
    FORM_TYPE: 'formType',
    ANSWERS: 'answers',
    FORM_DATA: 'formData',
    STARTED_AT: 'startedAt',
    USER_SLUG: 'userSlug',
    REVIEW_SLUG: 'reviewSlug',
    SUBMITTED_AT: 'submittedAt',
    INTRODUCTION: 'introduction',
    EDITING_SESSION_ID: 'editingSessionId',
  },
  Actions: {
    FETCH_REVIEW_FORMS_SUCCESS: 'reviewForms/FETCH_REVIEW_FORMS_SUCESS',
    UPDATE_REVIEW_FORMS_SUCCESS: 'reviewForms/UPDATE_REVIEW_FORMS_SUCCESS',
    CREATE_REVIEW_FORMS_SUCCESS: 'reviewForms/CREATE_REVIEW_FORMS_SUCCESS',
    DELETE_REVIEW_FORMS_SUCCESS: 'reviewForms/DELETE_REVIEW_FORMS_SUCCESS',
    SUBMIT_REVIEW_FORM_SUCCESS: 'reviewForms/SUBMIT_REVIEW_FORM_SUCCESS',
    UNSUBMIT_REVIEW_FORM_SUCCESS: 'reviewForms/UNSUBMIT_REVIEW_FORM_SUCCESS',
    REOPEN_REVIEW_FORM_SUCCESS: 'reviewForms/REOPEN_REVIEW_FORM_SUCCESS',
    UPDATE_REVIEW_FORM_COMPILER_SUCCESS: 'reviewForms/UPDATE_REVIEW_FORM_COMPILER_SUCCESS',
  },
};
